import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Slider from "../components/Slider";
import Services from "../components/Services";
import About from "../components/About";
import Testimonials from "../components/Testimonials";
import { Footer } from "../components";

function Home() {
    const location = useLocation();

    useEffect(() => {
        if (location.state?.scrollTo) {
            const targetId = location.state.scrollTo;
            const section = document.getElementById(targetId);
            if (section) {
                setTimeout(() => {
                    section.scrollIntoView({ behavior: "smooth" });
                }, 300); // wait for render
            }
        }
    }, [location]);


    useEffect(() => {
    if (location.hash) {
      const elementId = location.hash.replace("#", "");
      const scrollToElement = () => {
        const section = document.getElementById(elementId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      };

      // Try immediately, and again after small delay (for mobile render delay)
      scrollToElement();
      setTimeout(scrollToElement, 500);
    }
  }, [location]);

    return (
        <div>
            <Slider />
            <Services />
            <About />

            <div id="testimonials">
                <Testimonials />
            </div>
            <div id="contact"><Footer /></div>
        </div>
    );
}

export default Home;
